import React, { useState, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import Cookies from "js-cookie";
import axios from 'axios';

/**
 * Componente que renderiza o modal de edição de comprovante.
 * @param {boolean} open - Controla a visibilidade do modal.
 * @param {Function} handleClose - Função chamada para fechar o modal.
 * @param {Function} handleSave - Função chamada para salvar as alterações.
 * @param {number|string} comprovanteId - ID do comprovante que está sendo editado.
 */
function EditComprovanteModal({ open, handleClose, handleSave, comprovanteId }) {
    const [razao, setRazao] = useState('');

    useEffect(() => {
        if (open && comprovanteId) {
            // Buscar dados do comprovante para preencher o formulário
            axios.post('/api/getReceiptById', { token: Cookies.get('ANers'), id: comprovanteId }, { withCredentials: true })
                .then((response) => {
                    if (response.data.status === 200) {
                        setRazao(response.data.comprovante.razao);
                    } else {
                        alert('Erro ao buscar os dados do comprovante.');
                    }
                })
                .catch(() => {
                    alert('Erro ao buscar os dados do comprovante.');
                });
        }
    }, [open, comprovanteId]);

    /**
     * Manipula o salvamento das alterações.
     */
    const onSave = () => {
        if (!razao) {
            alert('Por favor, preencha o campo "Razão Social".');
            return;
        }
        handleSave(comprovanteId, { razao });
    };

    return (
        <Modal show={open} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Editar Comprovante</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Form.Group controlId="razao">
                        <Form.Label>Razão Social</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Digite a razão social"
                            value={razao}
                            onChange={(e) => setRazao(e.target.value)}
                        />
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Fechar
                </Button>
                <Button variant="primary" onClick={onSave}>
                    Salvar
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default EditComprovanteModal;
